import { render } from "./SubjectGroups.vue?vue&type=template&id=ad4196f0"
import script from "./SubjectGroups.vue?vue&type=script&lang=js"
export * from "./SubjectGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__